import React from 'react'

import { RadioCardGroup, RadioCardGroupProps } from '../../components/forms/radio-card-group/radio-card-group.js'

export interface ShippingCardsProps {
    groupProps: RadioCardGroupProps
}

export const ShippingCards = (props: ShippingCardsProps): JSX.Element => <RadioCardGroup {...props.groupProps} />
